import React from 'react';
import { firstError, firstErrorMessage } from '@/utils/errors';
import NotAuthorised from './NotAuthorised';
import Error from './Error';

const BasicErrorsWrapper = ({
  canAccess,
  children,
  entity,
  errors,
  exists,
}) => {
  if (firstError(errors)) { return <Error error={firstErrorMessage(errors)} className={`aridhia-${entity}-error`} />; }
  if (!exists) { return <div className="aridhia-panel-container-empty" />; }
  if (!canAccess) { return (<NotAuthorised />); }
  return (<>{ children }</>);
};

export default BasicErrorsWrapper;
